import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import buildings from "../../assets/images/buildings/buildings";
import { Slot, SlotType } from "../../lib/types";
import backgrounds from "../../assets/images/buildings/backgrounds";
import {
  cancelBuildingDemolition,
  openDialog,
} from "../../store/actions";
import { DragescentState } from "../../store/reducers/stateType";

interface IProps {
  slot: Slot;
  slotPrices: Array<{ gold: number, bricks: number, powerPoints: number }>;
  allBuildings: SlotType[];
  slotType: SlotType;
}

const SlotPerson = ({
  slot,
  slotPrices,
  allBuildings,
  slotType
}: IProps) => {
  const gold = useSelector((state: DragescentState) => state.governorate.resources.gold);
  const bricks = useSelector((state: DragescentState) => state.governorate.resources.bricks);
  const powerPoints = useSelector(
    (state: DragescentState) => state.governorate.resources["power-points"]
  ) || 0;
  const dispatch = useDispatch();
  const newBuildingRef = useRef(null);
  const actionButtonRef = useRef(null);

  console.log(powerPoints);

  return (
    <div className={"tile"} style={{ width: "175px", textAlign: "center", marginRight: "8px" }}>
                <span className={"image"}>
                  {slotType.id === 0 && <>
                    <img
                      src={backgrounds.background3}
                      alt="background"
                      width={"142"}
                      height={"152"}
                      style={{ width: "100%", maxWidth: "unset", height: "auto" }}
                    />
                    <a
                      className={"btn btn-black"}
                      ref={newBuildingRef}
                      onClick={() => dispatch(openDialog({
                        slotId: slot.id,
                        name: "NewBuilding",
                        // availableBuildings: tile.availableBuildings,
                        // tileTypeId: tile.typeId,
                        possible: false,
                        classes: ["new-manor"],
                        slotPrices,
                        elementRef: newBuildingRef.current
                      }))}
                    >
                      {/* <span className="info"> */}
                      {/*  <i className="icon icon-dum icon-xlg middle"/> */}
                      {/* </span> */}
                      Build
                    </a>
                  </>}
                  {!!slotType.id && <img
                    src={buildings[`b${slotType.imageId}`]}
                    width={"175"}
                    height={"187"}
                    alt=""
                    style={{ width: "100%", maxWidth: "unset", height: "auto" }}
                  />}
                  {!slot.inDemolition && !slot.damaged && !slot.turnsToBuilt
                  && !slot.turnsToUpgrade && !!slot.upgradeBuildings.length
                  && <a
                    className={"btn btn-black"}
                    ref={actionButtonRef}
                    onClick={() => dispatch(openDialog({
                      name: "UpgradeBuilding",
                      classes: ["new-manor", "upgrade"],
                      slot,
                      chainBuildings: allBuildings
                        .filter(b => b.chain === slotType.chain),
                      selectedBuilding: slotType.id,
                      gold,
                      bricks,
                      powerPoints,
                      slotPrices,
                      elementRef: actionButtonRef.current
                    }))}
                  >UPGRADE</a>}
                  {!slot.inDemolition && slot.turnsToBuilt
                    ? <>
                      <div className="overlay" style={{ height: `${slot.toBuiltPercents}%` }}/>
                      <span className="progress positive" style={{ top: `${slot.toBuiltPercents}%` }}/>
                      <span className="info">
                        <strong className="number">
                          {Math.round(100 - slot.toBuiltPercents)}<span className="space"> </span>%
                        </strong>
                        <span className="text-bigger">BUILDING</span><br/>
                        Turns: {slot.turnsToBuilt}
                      </span>
                    </> : <></>
                  }
                  {slot.type.id !== 0 && !slot.inDemolition && slot.damaged && !slot.turnsToBuilt
                    ? <>
                      <div className="overlay" style={{
                        height: `${slot.repaired && slot.repairTurns
                          ? 100 * (1 - slot.turnsToRepair / slot.repairTurns) : 0}%`
                      }}/>
                      <span className="progress negative" style={{
                        top: `${slot.repaired && slot.repairTurns
                          ? 100 * (1 - slot.turnsToRepair / slot.repairTurns) : 0}%`
                      }}/>
                      <span className="info">
                        <strong className="number">
                          {Math.round(100 - slot.health * 100)}
                          <span className="space"> </span>%
                        </strong>
                        {slot.repaired
                          ? <>
                            <span className="text-bigger">REPAIRING</span><br/>
                            Turns: {slot.turnsToRepair}<br/>
                          </>
                          : <>
                            <span className="text-bigger">DAMAGED</span><br />
                            <br />
                          </>}
                      </span>
                      {!slot.repaired && <a
                        className={"btn btn-black"}
                        ref={actionButtonRef}
                        onClick={() => dispatch(openDialog({
                          name: "RepairBuilding",
                          slot,
                          gold,
                          bricks,
                          powerPoints,
                          slotPrices,
                          elementRef: actionButtonRef.current
                        }))}
                      >
                        REPAIR
                      </a>}
                    </> : <></>
                  }
                  {!slot.inDemolition && !slot.damaged && slot.turnsToUpgrade
                    ? <>
                      <div className="overlay" style={{ height: `${slot.toUpgradePercents}%` }}/>
                      <span className="progress positive" style={{ top: `${slot.toUpgradePercents}%` }}/>
                      <span className="info">
                <strong className="number">
                  {100 - slot.toUpgradePercents}
                  <span className="space"> </span>%
                </strong>
                <span className="text-bigger">UPGRADE</span><br/>
                Turns: {slot.turnsToUpgrade}
              </span>
                    </> : <></>
                  }
                  {slot.inDemolition
                    ? <>
                      <div className="overlay" style={{ height: "100%" }}/>
                      <span className="progress negative" style={{ top: 0 }}/>
                      <span className="info">
                        <strong className={"number"}>
                          <i className="icon icon-md icon-zbourat"/><br/>
                        </strong>
                        <span className="text-bigger">DEMOLITION</span><br/>
                        Turns: 1
                      </span>
                      <a
                        onClick={() => dispatch(cancelBuildingDemolition(slot.id))}
                        className="btn btn-black btn-no-width"
                      >
                        Cancel
                      </a>
                    </> : <></>}
                </span>
    </div>
  )
}

export default SlotPerson;
